(() => {
  if (customElements.get('boysouls-bracelet-builder')) return;
  const weaveLabels = {
    'tiger-paracord-bracelet': ['W01', 'Ridge'],
    'vikings-bear-paracord-bracelet': ['W02', 'Chainline'],
    'ape-paracord-bracelet': ['W03', 'Crosslink'],
    'warrior-wolf-paracord-bracelet': ['W04', 'Centerline'],
    'wolf-paracord-bracelet': ['W05', 'Switchback'],
    'lion-paracord-bracelet': ['W06', 'Ripple'],
    'cacique-skull-paracord-bracelet': ['W07', 'Interlace'],
    'the-oni-paracord-bracelet': ['W08', 'Framework'],
    'the-dragon-paracord-bracelet': ['W09', 'Sideline'],
    'panther-paracord-bracelet': ['W10', 'Finegrain'],
    'anubis-paracord-bracelet': ['W11', 'Lattice'],
    'hawk-paracord-bracelet': ['W12', 'Twin Ridge'],
    'snake-paracord-bracelet': ['W13', 'Roundline'],
    'the-skull-paracord-bracelet': ['W14', 'Chevron'],
    'undead-samurai-paracord-bracelet': ['W15', 'Splitline'],
    'bear-paw-paracord-bracelet': ['W16', 'Ladder'],
    'undead-samurai-paracord-bracelet-ii': ['W17', 'Compact'],
    'hunter-paracord-bracelet': ['W18', 'Crossgrain'],
    'khonsu-paracord-bracelet': ['W19', 'Stepline'],
    'lion-ii-paracord-bracelet': ['W20', 'Mosaic'],
    'wild-boar-paracord-bracelet': ['W21', 'Interlock'],
    'khonsu-ii-paracord-bracelet': ['W22', 'Coil'],
    'zombie-samurai-paracord-bracelet': ['W23', 'Spine'],
    'the-dragon-ii-paracord-bracelet': ['W24', 'Flowline']
  };
  const cordTypes = { cord550: '550', cord275: '275', microCord: 'micro' };
  const thinCordWeaves = new Set(['tiger-paracord-bracelet', 'warrior-wolf-paracord-bracelet', 'hawk-paracord-bracelet', 'zombie-samurai-paracord-bracelet']);
  const microCordWeaves = new Set(['tiger-paracord-bracelet', 'wolf-paracord-bracelet', 'cacique-skull-paracord-bracelet', 'the-oni-paracord-bracelet', 'hawk-paracord-bracelet', 'undead-samurai-paracord-bracelet', 'the-dragon-ii-paracord-bracelet']);
  class BoysoulsBraceletBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-builder-config]').textContent);
      this.config.catalogs.weave.forEach(product => {
        const label = weaveLabels[product.handle];
        if (label) [product.code, product.title] = label;
      });
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.t = this.config.strings;
      this.keys = ['weave', 'cord', 'clasp'];
      this.selection = {};
      this.step = 0;
      this.limit = 12;
      this.root = (this.config.root || '/').replace(/\/?$/, '/');
      this.productCache = new Map();
      this.money = new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency: this.config.currency || 'USD' });
      this.addEventListener('click', (event) => this.handleClick(event));
      this.q('[data-search]').addEventListener('input', () => { this.limit = 12; this.renderCatalog(); });
      this.q('[data-sort]').addEventListener('change', () => this.renderCatalog());
      this.q('[data-variant]').addEventListener('change', () => this.chooseVariant());
      this.q('[data-unit]').addEventListener('change', () => this.changeUnit());
      this.form.addEventListener('input', () => { this.attemptId = null; this.q('[data-note-count]').textContent = `${this.q('[data-notes]').value.length} / 1000`; this.update(); });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.submitOrder(); });
      window.addEventListener('pageshow', () => {
        if (!this.busy) return;
        this.busy = false; this.form.inert = false; this.form.removeAttribute('aria-busy'); this.update();
      });
      this.showStep(0, false);
      if (!this.config.baseProduct.handle || !this.config.baseProduct.available) this.showError(this.t.not_configured, false);
    }
    q(selector) { return this.querySelector(selector); }
    productLabel(product) { return product.code ? `${product.code} / ${product.title}` : product.title; }
    requiredCords() {
      const handle = this.selection.weave?.product.handle;
      if (!weaveLabels[handle]) return [];
      return [handle !== 'tiger-paracord-bracelet' && 'cord550', thinCordWeaves.has(handle) && 'cord275', microCordWeaves.has(handle) && 'microCord'].filter(Boolean);
    }
    activeKey() { return this.keys[this.step] === 'cord' ? this.cordKey : this.keys[this.step]; }
    catalogFor(key) {
      if (cordTypes[key]) {
        const products = key === 'cord550' ? this.config.catalogs.cord : [...(this.config.catalogs.thinCord || this.config.catalogs.cord), ...(this.config.catalogs.microCord || [])];
        return [...new Map(products.map(product => [product.handle, product])).values()].filter(product => product.cordType === cordTypes[key]);
      }
      return this.config.catalogs[key] || [];
    }
    summaryKeys() { const cords = this.requiredCords(); return ['weave', ...(cords.length ? cords : ['cord']), 'clasp']; }
    node(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    handleClick(event) {
      if (this.busy) return;
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-step')) this.showStep(Number(button.dataset.step));
      if (button.hasAttribute('data-edit')) this.showStep(Number(button.dataset.edit));
      if (button.hasAttribute('data-cord-type')) this.showStep(1, true, button.dataset.cordType);
      if (button.hasAttribute('data-product')) this.chooseProduct(button.dataset.product);
      if (button.hasAttribute('data-variant-choice')) { this.q('[data-variant]').value = button.dataset.variantChoice; this.chooseVariant(); }
      if (button.hasAttribute('data-load-more')) { this.limit += 24; this.renderCatalog(); }
      if (button.hasAttribute('data-back')) this.showStep(this.step - 1);
      if (button.hasAttribute('data-start-design')) this.showStep(this.step);
      if (button.hasAttribute('data-next') || button.hasAttribute('data-mobile-next')) {
        if (this.step < 3) this.showStep(this.step + 1);
        else this.form.requestSubmit();
      }
    }
    showStep(index, focus = true, cordKey = null) {
      clearTimeout(this.advanceTimer);
      const firstIncomplete = this.keys.findIndex(key => !this.complete(key));
      if (firstIncomplete !== -1) index = Math.min(index, firstIncomplete);
      this.step = Math.max(0, Math.min(3, index));
      if (this.step === 1) {
        const required = this.requiredCords();
        this.cordKey = required.includes(cordKey) ? cordKey : (required.find(key => !this.complete(key)) || required[0]);
      }
      this.dataset.activeStep = this.step;
      this.limit = 12;
      this.q('[data-error]').hidden = true;
      this.q('[data-search]').value = '';
      this.q('[data-sort]').value = 'featured';
      this.q('[data-catalog-panel]').hidden = this.step === 3;
      this.q('[data-details-panel]').hidden = this.step !== 3;
      this.q('[data-back]').hidden = this.step === 0;
      this.querySelectorAll('[data-step]').forEach((button, i) => {
        if (i === this.step) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      if (this.step < 3) {
        this.q('[data-panel-title]').textContent = this.config.stepTitles[this.step];
        this.q('[data-panel-description]').textContent = this.config.stepDescriptions[this.step];
        this.q('[data-step-caption]').textContent = `0${this.step + 1} / 04`;
        this.renderCordTypes();
        this.renderCatalog();
        this.renderVariants();
      }
      else this.q('[data-cord-panel]').hidden = true;
      this.update();
      if (focus) {
        const title = this.q(this.step === 3 ? '[data-details-panel] h2' : '[data-panel-title]');
        title.focus({ preventScroll: true });
        title.scrollIntoView({ behavior: 'instant', block: 'start' });
        this.panelAnimation?.cancel();
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.panelAnimation = this.q(this.step === 3 ? '[data-details-panel]' : '[data-catalog-panel]').animate([{ opacity: .5, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
        }
      }
    }
    advanceFrom(key) {
      clearTimeout(this.advanceTimer);
      const index = cordTypes[key] ? 1 : this.keys.indexOf(key);
      const handle = this.selection[key]?.product.handle;
      if (this.step !== index || this.activeKey() !== key || !this.complete(key)) return;
      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 160;
      this.advanceTimer = setTimeout(() => {
        if (!this.busy && this.step === index && this.activeKey() === key && this.selection[key]?.product.handle === handle && this.complete(key)) {
          if (cordTypes[key] && !this.complete('cord')) this.showStep(1);
          else this.showStep(index + 1);
        }
      }, delay);
    }
    renderCordTypes() {
      const panel = this.q('[data-cord-panel]');
      panel.hidden = this.step !== 1;
      if (panel.hidden) return;
      const required = this.requiredCords();
      this.q('[data-cord-requirements]').textContent = `${this.productLabel(this.selection.weave.product)} · ${this.t.required_cords} ${required.map(key => this.t[key]).join(' + ')}`;
      const group = this.q('[data-cord-types]');
      group.replaceChildren();
      required.forEach((key, index) => {
        const button = this.node('button', 'bs-builder__cord-type');
        button.type = 'button'; button.dataset.cordType = key;
        button.setAttribute('aria-pressed', String(this.cordKey === key));
        button.append(this.node('span', '', this.complete(key) ? '✓' : String(index + 1)), this.node('strong', '', this.t[key]), this.node('small', '', this.complete(key) ? this.t.selection_ready : this.t.required));
        group.append(button);
      });
    }
    renderCatalog() {
      const key = this.activeKey();
      if (!key) return;
      const normalize = value => value.toLowerCase().replace(/[\s._·-]+/g, '');
      const query = normalize(this.q('[data-search]').value);
      let products = this.catalogFor(key).filter(p => normalize(`${p.code || ''} ${p.title} ${p.handle} ${cordTypes[key] ? this.t[key] : ''}`).includes(query));
      if (this.q('[data-sort]').value === 'az') products = [...products].sort((a,b) => a.title.localeCompare(b.title));
      const grid = this.q('[data-product-grid]');
      grid.replaceChildren();
      products.slice(0, this.limit).forEach((product) => {
        const chosen = this.selection[key]?.product.handle === product.handle && this.complete(key);
        const button = this.node('button', 'bs-builder__card');
        button.type = 'button';
        button.dataset.product = product.handle;
        button.setAttribute('aria-pressed', String(chosen));
        button.disabled = key !== 'weave' && !product.available;
        const media = this.node('span', 'bs-builder__card-image');
        if (product.image) {
          const image = this.node('img');
          image.src = product.image;
          image.alt = '';
          image.width = 300;
          image.height = 300;
          image.loading = 'lazy';
          media.append(image);
        }
        const check = this.node('span', 'bs-builder__card-check', '✓');
        check.setAttribute('aria-hidden', 'true');
        media.append(check);
        const count = product.variants?.length || 0;
        const weavePrice = key === 'weave' ? this.pricing(product) : null;
        const meta = key === 'weave' ? `${this.t.custom_price} ${weavePrice.unit === null ? this.t.choose_weave : this.money.format(weavePrice.unit / 100)}` : (!product.available ? this.t.unavailable : (count > 1 ? `${count} ${this.t.options}` : this.t.choose));
        button.append(media, this.node('span', 'bs-builder__card-title', this.productLabel(product)), this.node('small', '', meta));
        grid.append(button);
      });
      this.q('[data-result-count]').textContent = `${products.length} ${this.t.results}`;
      this.q('[data-empty]').hidden = products.length !== 0;
      this.q('[data-empty]').textContent = this.t.no_results;
      this.q('[data-load-more]').hidden = products.length <= this.limit;
      this.q('[data-truncated]').hidden = !this.config.truncated;
    }
    async productData(handle, fresh = false) {
      if (!fresh && this.productCache.has(handle)) return this.productCache.get(handle);
      const path = this.config.preview ? `/catalog/${encodeURIComponent(handle)}.json` : `${this.root}products/${encodeURIComponent(handle)}.js`;
      const response = await fetch(path, { headers: { Accept: 'application/json' }, cache: fresh ? 'no-store' : 'default' });
      if (!response.ok) throw new Error(this.t.load_error);
      const product = await response.json();
      this.productCache.set(handle, product);
      return product;
    }
    async chooseProduct(handle) {
      clearTimeout(this.advanceTimer);
      const key = this.activeKey();
      const product = this.catalogFor(key).find(p => p.handle === handle);
      if (!product || (key !== 'weave' && !product.available)) return;
      if (this.selection[key]?.product.handle === handle && product.variantsComplete) {
        if (this.complete(key)) this.advanceFrom(key);
        else if (key !== 'weave') this.focusVariant();
        return;
      }
      this.q('[data-error]').hidden = true;
      this.attemptId = null;
      this.selection[key] = { product, variant: null };
      if (key === 'weave') {
        Object.keys(cordTypes).forEach(cordKey => { delete this.selection[cordKey]; });
        this.renderCatalog(); this.renderVariants(); this.update(); this.advanceFrom(key); return;
      }
      if (!product.variantsComplete) {
        this.renderCatalog(); this.renderVariants(); this.update();
        this.q('[data-selection-status]').textContent = this.t.loading;
        this.q('[data-next]').disabled = true;
        this.q('[data-mobile-next]').disabled = true;
        try {
          const data = await this.productData(handle);
          product.variants = data.variants.map(v => ({ id: v.id, title: v.title, available: v.available, image: typeof v.featured_image === 'object' ? v.featured_image?.src : null }));
          product.variantsComplete = true;
          product.available = data.available;
        } catch (error) {
          if (this.selection[key]?.product.handle === handle) delete this.selection[key];
          this.renderCatalog(); this.renderVariants();
          this.showError(this.t.load_error);
          this.update();
          return;
        }
      }
      if (this.selection[key]?.product.handle !== handle) return;
      const available = product.variants.filter(v => v.available);
      if (product.variants.length === 1 && available.length === 1) this.selection[key].variant = available[0];
      this.renderCatalog(); this.renderVariants(); this.update();
      if (!this.selection[key].variant && this.activeKey() === key) this.focusVariant();
      this.advanceFrom(key);
    }
    focusVariant() {
      (this.q('[data-variant-choices]:not([hidden]) button:not(:disabled)') || this.q('[data-variant]')).focus({ preventScroll: true });
      this.q('[data-variant-panel]').scrollIntoView({ behavior: 'instant', block: 'start' });
    }
    chooseVariant() {
      const key = this.activeKey();
      const selected = this.selection[key];
      if (!selected) return;
      selected.variant = selected.product.variants.find(v => String(v.id) === this.q('[data-variant]').value && v.available) || null;
      this.attemptId = null;
      this.renderCatalog(); this.renderVariants();
      this.update();
      this.advanceFrom(key);
    }
    pricing(product = this.selection.weave?.product, variants = this.config.baseProduct.variants || []) {
      if (!product) return { unit: null, variant: null, valid: false };
      const variant = variants.find(v => v.sku === `BS-CUSTOM-${product.handle}`);
      const unit = this.config.currency === 'USD' ? this.config.fixedPriceUsd : (variant?.price ?? null);
      const valid = Boolean(variant?.available && Number.isInteger(unit) && unit > 0 && variant.price === unit);
      return { unit, variant, valid };
    }
    complete(key) {
      if (key === 'cord') { const required = this.requiredCords(); return required.length > 0 && required.every(cordKey => this.complete(cordKey)); }
      const selected = this.selection[key];
      if (cordTypes[key] && (!this.requiredCords().includes(key) || selected?.product.cordType !== cordTypes[key])) return false;
      return Boolean(selected && (key === 'weave' || selected.variant?.available));
    }
    choiceText(key) {
      if (key === 'cord' && this.requiredCords().length) return this.requiredCords().map(cordKey => `${this.t[cordKey]}: ${this.choiceText(cordKey)}`).join('; ');
      const selected = this.selection[key];
      if (!selected) return `${this.t.choose} ${this.t[key].toLowerCase()}`;
      if (cordTypes[key] && !selected.variant && selected.product.variants?.length > 1) return `${this.productLabel(selected.product)} · ${this.t.variant}`;
      const variant = selected.variant?.title;
      return `${this.productLabel(selected.product)}${variant && variant !== 'Default Title' ? ` · ${variant}` : ''}`;
    }
    renderVariants() {
      const key = this.activeKey();
      const selected = this.selection[key];
      const panel = this.q('[data-variant-panel]');
      panel.hidden = !selected || key === 'weave';
      if (panel.hidden) return;
      this.q('[data-selected-title]').textContent = selected.product.title;
      this.q('[data-selected-link]').href = this.config.preview ? `https://boysouls.com${selected.product.url}` : selected.product.url;
      const select = this.q('[data-variant]');
      select.disabled = !selected.product.variantsComplete;
      select.replaceChildren();
      const placeholder = this.node('option', '', this.t.variant);
      placeholder.value = ''; placeholder.disabled = true;
      select.append(placeholder);
      selected.product.variants.forEach(v => {
        const option = this.node('option', '', `${v.title === 'Default Title' ? this.t.standard : v.title}${v.available ? '' : ` — ${this.t.unavailable}`}`);
        option.value = v.id; option.disabled = !v.available; select.append(option);
      });
      select.value = selected.variant ? String(selected.variant.id) : '';
      const choices = this.q('[data-variant-choices]');
      const showChoices = Boolean(cordTypes[key] && selected.product.variants.length > 1);
      choices.hidden = !showChoices;
      select.hidden = showChoices;
      choices.replaceChildren();
      if (showChoices) selected.product.variants.forEach(variant => {
        const button = this.node('button', 'bs-builder__variant-choice');
        button.type = 'button'; button.dataset.variantChoice = String(variant.id);
        button.disabled = !variant.available;
        button.setAttribute('aria-pressed', String(selected.variant?.id === variant.id));
        if (variant.image) {
          const image = this.node('img');
          image.src = variant.image; image.alt = ''; image.width = 120; image.height = 120; image.loading = 'lazy';
          button.append(image);
        }
        button.append(this.node('span', '', `${variant.title}${variant.available ? '' : ` — ${this.t.unavailable}`}`));
        choices.append(button);
      });
    }
    changeUnit() {
      const field = this.q('[data-wrist]');
      const inches = this.q('[data-unit]').value === 'in';
      if (field.value) field.value = String(Math.round(Number(field.value) * (inches ? 1 / 2.54 : 2.54) * 10) / 10);
      field.min = inches ? '4' : '10'; field.max = inches ? '12' : '30';
      field.placeholder = inches ? '7.1' : '18.0';
      this.attemptId = null;
      this.update();
    }
    properties() {
      const value = this.q('[data-wrist]').value;
      const unit = this.q('[data-unit]').value;
      const data = {};
      this.summaryKeys().forEach(key => {
        const selected = this.selection[key];
        if (!selected) return;
        const label = key === 'weave' ? 'Weave reference' : (cordTypes[key] ? this.t[key] : key[0].toUpperCase() + key.slice(1));
        data[label] = this.choiceText(key);
        data[`_${label} product`] = `https://boysouls.com${selected.product.url}`;
        if (selected.variant) data[`_${label} variant ID`] = String(selected.variant.id);
      });
      data['Wrist circumference'] = `${value} ${unit}`;
      const notes = this.q('[data-notes]').value.trim();
      if (notes) data['Customization notes'] = notes;
      data._pricing_rule = 'Fixed USD 99 per bracelet';
      data._unit_price = `${this.config.currency} ${(this.pricing().unit / 100).toFixed(2)}`;
      return data;
    }
    update() {
      this.renderCordTypes();
      const count = this.keys.filter(k => this.complete(k)).length;
      const summary = this.q('[data-summary-items]');
      summary.replaceChildren();
      this.summaryKeys().forEach((key, i) => {
        const selected = this.selection[key];
        const row = this.node('div', 'bs-builder__summary-item');
        const thumb = this.node('div', 'bs-builder__thumb');
        const imageUrl = selected?.variant?.image || selected?.product.image;
        if (imageUrl) { const img = this.node('img'); img.src = imageUrl; img.alt = ''; img.width = 88; img.height = 88; thumb.append(img); }
        else thumb.textContent = `0${i + 1}`;
        const copy = this.node('div');
        copy.append(this.node('small', '', this.t[key]), this.node('strong', '', this.choiceText(key)));
        const edit = this.node('button', 'bs-builder__edit', '↗');
        edit.type = 'button';
        if (cordTypes[key]) edit.dataset.cordType = key;
        else edit.dataset.edit = this.keys.indexOf(key);
        edit.setAttribute('aria-label', `${this.t.edit} ${this.t[key].toLowerCase()}`);
        row.append(thumb, copy, edit); summary.append(row);
      });
      this.keys.forEach((key, i) => {
        const stepButton = this.q(`[data-step="${i}"]`);
        stepButton.classList.toggle('is-complete', this.complete(key));
        stepButton.querySelector('[data-step-number]').textContent = this.complete(key) ? '✓' : String(i + 1);
      });
      this.q('[data-progress]').style.transform = `scaleX(${count / 3})`;
      this.q('[data-progress-label]').textContent = `${count} / 3`;
      const quantity = Math.max(1, Number(this.q('[data-quantity]').value) || 1);
      const pricing = this.pricing();
      const options = this.config.catalogs.weave.map(p => this.pricing(p).unit).filter(Number.isInteger);
      const unitPrice = pricing.unit ?? options[0];
      const price = Number.isInteger(unitPrice) ? this.money.format(unitPrice / 100 * quantity) : this.t.choose_weave;
      this.q('[data-price]').textContent = price;
      this.q('[data-mobile-price]').textContent = price;
      this.form.querySelector('input[name="id"]').value = pricing.valid ? pricing.variant.id : '';
      const label = this.busy ? this.t.adding : (this.step === 3 ? this.t.add : (this.step === 2 ? this.t.review : this.t.continue));
      this.q('[data-next-label]').textContent = label;
      this.q('[data-mobile-next]').textContent = label;
      this.q('[data-next]').hidden = this.step < 3;
      this.q('[data-mobile-next]').hidden = this.step < 3;
      this.q('[data-mobile-hint]').hidden = this.step === 3;
      this.q('[data-mobile-hint]').textContent = `${this.step + 1} / 4 · ${this.t[this.keys[this.step]] || this.t.details}`;
      const enabled = Boolean(this.config.baseProduct.available && !this.busy && (this.step === 3 ? count === 3 && pricing.valid : this.complete(this.keys[this.step])));
      this.q('[data-next]').disabled = !enabled;
      this.q('[data-mobile-next]').disabled = !enabled;
      this.q('[data-selection-status]').textContent = this.step === 3 ? (count === 3 && !pricing.valid ? this.t.pricing_unavailable : `${count} / 3 ${this.t.selected}`) : (this.complete(this.keys[this.step]) ? this.t.selection_ready : this.t.select_prompt);
      const review = this.q('[data-review]');
      review.replaceChildren();
      this.summaryKeys().forEach(key => {
        const row = this.node('p'); row.append(this.node('span', '', this.t[key]), this.node('strong', '', this.choiceText(key))); review.append(row);
      });
      const mailBody = ['Hello Boysouls,', '', 'I have a question about my custom bracelet.', '', ...this.summaryKeys().filter(key => this.selection[key]).map(key => `${this.t[key]}: ${this.choiceText(key)}`), '', 'My question:', ''].join('\n');
      this.querySelectorAll('[data-support-mail]').forEach(link => {
        link.href = `mailto:${this.config.supportEmail || 'support@boysouls.com'}?subject=${encodeURIComponent('Boysouls custom bracelet question')}&body=${encodeURIComponent(mailBody)}`;
      });
    }
    showError(message, focus = true) {
      const error = this.q('[data-error]'); error.textContent = message; error.hidden = false;
      if (focus) error.focus();
    }
    async submitOrder() {
      if (this.busy) return;
      const missing = this.keys.findIndex(k => !this.complete(k));
      if (missing !== -1) { this.showStep(missing); this.showError(this.t.select_error); return; }
      if (this.step !== 3) this.showStep(3);
      if (!this.form.reportValidity()) return;
      const displayedPricing = this.pricing();
      if (!displayedPricing.valid) { this.showError(this.t.pricing_unavailable); return; }
      const properties = this.properties();
      const quantity = Number(this.q('[data-quantity]').value);
      this.busy = true; this.form.inert = true; this.form.setAttribute('aria-busy', 'true'); this.update();
      this.q('[data-error]').hidden = true;
      let adding = false;
      this.attemptId ||= crypto.randomUUID();
      properties._configuration_id = this.attemptId;
      try {
        const components = [...this.requiredCords().map(key => this.selection[key]), this.selection.clasp];
        const [base, ...liveComponents] = await Promise.all([
          this.productData(this.config.baseProduct.handle, true),
          ...components.map(selected => this.productData(selected.product.handle, true))
        ]);
        const livePricing = this.pricing(this.selection.weave.product, base.variants);
        this.config.baseProduct.variants = base.variants;
        if (!livePricing.valid) throw new Error(this.t.pricing_unavailable);
        const variant = livePricing.variant;
        if (!liveComponents.every((product, index) => product.variants.some(v => String(v.id) === String(components[index].variant.id) && v.available))) throw new Error(this.t.stock_error);
        if (livePricing.unit !== displayedPricing.unit) throw new Error(this.t.changed_price);
        adding = true;
        const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity, properties }] }) });
        if (!response.ok) {
          adding = false;
          const data = await response.json().catch(() => ({}));
          throw new Error(typeof data.description === 'string' ? data.description : this.t.cart_error);
        }
        window.location.assign(`${this.root}checkout`);
        return;
      } catch (error) {
        if (adding) {
          try {
            const response = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!response.ok) throw new Error();
            const cart = await response.json();
            if (cart.items.some(item => item.properties?._configuration_id === this.attemptId)) { window.location.assign(`${this.root}checkout`); return; }
          } catch (_) {
            this.showError(this.t.uncertain_error, false);
            const link = this.node('a', '', ` ${this.t.view_cart}`); link.href = `${this.root}cart`; this.q('[data-error]').append(link);
            this.form.inert = false; this.form.removeAttribute('aria-busy'); this.q('[data-error]').focus();
            return;
          }
        }
        this.busy = false; this.form.inert = false; this.form.removeAttribute('aria-busy'); this.update();
        this.showError(error.message || this.t.cart_error);
      }
    }
  }
  customElements.define('boysouls-bracelet-builder', BoysoulsBraceletBuilder);
})();
